<mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="pinnedPanels[silentDataKey]"
    #classicCareExpansionPanel
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">phone</mat-icon>
            <b>Classic Care</b>
        </mat-panel-title>
        <mat-panel-description class="end-center flex-row">
            @if (classicCareExpansionPanel.expanded || silentData[silentDataKey]) {
                <button mat-icon-button (click)="togglePanelPinned($event, silentDataKey)">
                    <mat-icon svgIcon="pin" [ngClass]="{ 'cb-accent': silentData[silentDataKey] }">
                    </mat-icon>
                </button>
            }
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        @if (contactField.isVisible) {
            <cb-display-value-new class="flex" label="Contact">
                {{ lotMappedItem?.clientSale?.classicCareContact?.name | cbDasher }}
            </cb-display-value-new>
        }
        <div class="flex-row">
            @if (contactMethodField.isVisible) {
                <cb-display-value-new class="flex" label="Contact Method">
                    {{
                        CONTACT_METHOD_ENUM[
                            lotMappedItem?.clientSale?.classicCareContact?.preferredContact
                        ]
                    }}
                </cb-display-value-new>
            }
            @if (contactDetailField.isVisible) {
                <cb-display-value-new class="flex" label="Contact Detail">
                    {{
                        lotMappedItem?.clientSale?.classicCareContact?.preferredContactDetails
                            | cbDasher
                    }}
                </cb-display-value-new>
            }
        </div>
    </div>
</mat-expansion-panel>
